import {
  ICalloutContentStyles,
  ITooltipHost,
  ITooltipHostProps as FITooltipHostProps,
  ITooltipHostStyles,
  TooltipHost as FTooltipHost,
} from '@fluentui/react';
import { forwardRef } from 'react';

import { IComponent, IStyleFunctionOrObject } from '../../models/components.models';
import { calloutContentStylesPopover } from '../../themes/themes';
import { useThemeStyles } from '../../utils/hooks';
import { tooltipHostStylesDefault } from './TooltipHost.styles';

export interface ITooltipHostProps
  extends Omit<FITooltipHostProps, 'styles' | 'calloutProps'>,
    IComponent<ITooltipHostStyles> {
  calloutContentStyles?:
    | IStyleFunctionOrObject<ICalloutContentStyles>
    | IStyleFunctionOrObject<ICalloutContentStyles>[];
}

export const TooltipHost = forwardRef<ITooltipHost, ITooltipHostProps>((props, ref) => {
  const { styles, calloutContentStyles, ..._fProps } = props;
  const fProps: FITooltipHostProps = {
    ..._fProps,
    styles: useThemeStyles<Partial<ITooltipHostStyles>>(tooltipHostStylesDefault, styles),
    calloutProps: {
      styles: useThemeStyles<Partial<ICalloutContentStyles>>(calloutContentStylesPopover, calloutContentStyles),
    },
  };
  return <FTooltipHost {...fProps} componentRef={ref as any} data-test={props['data-test'] || 'tooltip-host'} />;
});
